import React from "react";
import DatePickerInput from '../../DatePickerInput/DatePickerInput';

export default class AdjustChartWidget extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      chartWidgetOpen: false,
      report_details: this.props.report_details,
    };
  };

  render(){
    // console.log('AdjustChart', this.state)
    return (
      <div className="col-sm-2 flexed content-right AdjustChartWidget" id="AdjustChartWidget">
        {
          this.state.chartWidgetOpen
            ?
            <div className="popover-preview adjust-chart-details-popover">
              {this.renderPopoverHeader()}
              {this.renderDateGrouping()}
              {this.renderDateRange()}
              {this.renderSubmitButton()}
              {this.props.columnId ? this.renderActions() : null}
            </div>
            :
            null
        }
        <div className="ss-list" onClick={() => this.setState({ chartWidgetOpen: !this.state.chartWidgetOpen })}></div>
      </div>
    );
  };

  renderPopoverHeader() {
    return (
      <div className="popover-heading">
        <h3><div className="model-card" style={{ paddingLeft: '10px' }}><span className="ss-shuffle">&nbsp;</span></div>{I18n.t('adjust_details')}</h3>
        <div className="popover-close-wrapper"><button type="button" className="close" onClick={() => this.setState({chartWidgetOpen: false})}><span aria-hidden="true">x</span><span className="sr-only">Close</span></button></div>
      </div>
    );
  };

  renderDateGrouping() {
    if (this.state.report_details.chart_type.name === 'line_chart') {
      return (
        <div className="col-xs-12 pop-bd-el">
          <div className="form-group">
            <label>{`${I18n.t('group_by')}`}</label>
            <select id={`grouping-select-${this.state.report_details.id}`} className='form-control' defaultValue={this.state.report_details.x_grouping ? this.state.report_details.x_grouping : ''} onChange={this.onChange} name='x_grouping'>
              <option value=''></option>
              <option value='days'>{I18n.t('Days')}</option>
              <option value='weeks'>{I18n.t('weeks')}</option>
              <option value='months'>{I18n.t('months')}</option>
            </select>
          </div>
        </div>
      );
    };
  };

  renderDateRange() {
    return (
      [
        <div className="col-xs-12 pop-bd-el" key="start_date">
          <div className="form-group">
            <label>{`${I18n.t('start')}`}</label>
            <DatePickerInput
              selectedDate={this.state.report_details.start_date ? this.state.report_details.start_date : ''}
              dateFormat={this.props.date_format}
              onChange={this.onChangeStartDate}
              minDate={new Date('2000-01-01')}
            />
          </div>
        </div>,
        <div className="col-xs-12 pop-bd-el" key="end_date">
          <div className="form-group">
            <label>{`${I18n.t('end')}`}</label>
            <DatePickerInput
              selectedDate={this.state.report_details.end_date ? this.state.report_details.end_date : ''}
              dateFormat={this.props.date_format}
              onChange={this.onChangeEndDate}
              minDate={new Date('2000-01-01')}
            />
            <div><input type='checkbox' name='includeYOY' onChange={this.onChange} checked={this.state.report_details.includeYOY ? this.state.report_details.includeYOY : false} /> <span>{I18n.t('year_over_year')}</span></div>
          </div>
        </div>
      ]
    );
  };

  renderSubmitButton() {
    return (
      <div className="col-xs-12 pop-bd-el" >
        <div className="popover-close-wrapper" style={{ height: '40px' }}>
          <button type="button" id={`adjust-details-button-${this.state.report_details.id}`} className={"btn btn-primary btn-sm"} style={{ marginTop: '5px' }} onClick={() => { this.props.onClickSideBarSubmit(this.state.report_details); this.setState({ chartWidgetOpen: false});}} >
            <span><span style={{ marginLeft: 5 }}>{I18n.t('submit')}</span></span>
          </button>
        </div>
      </div>
    );
  };

  renderActions() {
    var actions = [<a key={'edit'} href={`/admin/reports/report_details/${this.state.report_details.id}/edit`} className='btn btn-sm modal-iframe' data-fullscreen='true'>{I18n.t('edit')}</a>, <a key={'view'} href={`/admin/reports/report_details/${this.state.report_details.id}`} className='btn btn-sm modal-iframe' data-fullscreen='true'>{I18n.t('view')}</a>]

    return (
      <div>
        <hr style={{ margin: '5px 0 10px 0' }} />
        <div className="quick-links">{actions}</div>
      </div>
    );
  };

  onChangeStartDate = (value) => {
    var report_details = Object.assign({}, this.state.report_details);
    report_details.start_date = value;
    this.setState({ report_details: report_details });
    // this.props.onChange(value, 'start_date', true);
  };

  onChangeEndDate = (value) => {
    var report_details = Object.assign({}, this.state.report_details);
    report_details.end_date = value;
    this.setState({report_details :report_details});
    // this.props.onChange(value, 'end_date', true);
  };

  onChange = (e) => {
    var report_details = Object.assign({}, this.state.report_details);
    e.target.name == "includeYOY" ? report_details[e.target.name] = e.target.checked : report_details[e.target.name] = e.target.value
    this.setState({report_details: report_details});
  };

}